export function ChevronRightIcon({ size = 24 }) {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M8.58984 16.58L13.1698 12L8.58984 7.41L9.99984 6L15.9998 12L9.99984 18L8.58984 16.58Z'
        fill='currentColor'
      />
    </svg>
  )
}

export function ChevronLeftIcon({ size = 24 }) {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M15.41 16.58L10.83 12L15.41 7.41L14 6L8 12L14 18L15.41 16.58Z' fill='currentColor' />
    </svg>
  )
}

export function MenuIcon({ size = 24 }) {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M3 6H21V8H3V6ZM3 11H21V13H3V11ZM3 16H21V18H3V16Z' fill='currentColor' />
    </svg>
  )
}

export function ChatIcon({ size = 24 }) {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M20 2H4C3.46957 2 2.96086 2.21071 2.58579 2.58579C2.21071 2.96086 2 3.46957 2 4V22L6 18H20C20.5304 18 21.0391 17.7893 21.4142 17.4142C21.7893 17.0391 22 16.5304 22 16V4C22 3.46957 21.7893 2.96086 21.4142 2.58579C21.0391 2.21071 20.5304 2 20 2ZM6 9H18V11H6M14 14H6V12H14M18 8H6V6H18'
        fill='currentColor'
      />
    </svg>
  )
}

export function VRIcon({ size = 24 }) {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M5 3C3.89 3 3 3.9 3 5V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V5C21 4.46957 20.7893 3.96086 20.4142 3.58579C20.0391 3.21071 19.5304 3 19 3H5ZM6 9H7.5L8.5 12.43L9.5 9H11L9.25 15H7.75L6 9ZM13 9H16.5C17.35 9 18 9.65 18 10.5V11.5C18 12.1 17.6 12.65 17.1 12.9L18 15H16.5L15.65 13H14.5V15H13V9ZM14.5 10.5V11.5H16.5V10.5H14.5Z'
        fill='currentColor'
      />
    </svg>
  )
}

export function KeyboardIcon({ size = 24 }) {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M19 10H17V8H19M19 13H17V11H19M16 10H14V8H16M16 13H14V11H16M16 17H8V15H16M7 10H5V8H7M7 13H5V11H7M8 11H10V13H8M8 8H10V10H8M11 11H13V13H11M11 8H13V10H11M20 5H4C2.89 5 2 5.89 2 7V17C2 17.5304 2.21071 18.0391 2.58579 18.4142C2.96086 18.7893 3.46957 19 4 19H20C20.5304 19 21.0391 18.7893 21.4142 18.4142C21.7893 18.0391 22 17.5304 22 17V7C22 5.89 21.1 5 20 5Z'
        fill='currentColor'
      />
    </svg>
  )
}

export function MicIcon({ size = 24 }) {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M12 2C12.7956 2 13.5587 2.31607 14.1213 2.87868C14.6839 3.44129 15 4.20435 15 5V11C15 11.7956 14.6839 12.5587 14.1213 13.1213C13.5587 13.6839 12.7956 14 12 14C11.2044 14 10.4413 13.6839 9.87868 13.1213C9.31607 12.5587 9 11.7956 9 11V5C9 4.20435 9.31607 3.44129 9.87868 2.87868C10.4413 2.31607 11.2044 2 12 2ZM19 11C19 14.53 16.39 17.44 13 17.93V21H11V17.93C7.61 17.44 5 14.53 5 11H7C7 12.3261 7.52678 13.5979 8.46447 14.5355C9.40215 15.4732 10.6739 16 12 16C13.3261 16 14.5979 15.4732 15.5355 14.5355C16.4732 13.5979 17 12.3261 17 11H19Z'
        fill='currentColor'
      />
    </svg>
  )
}

export function MicOffIcon({ size = 24 }) {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M19 11C19 12.19 18.66 13.3 18.1 14.28L16.87 13.05C17.14 12.43 17.3 11.74 17.3 11H19ZM15 11.16L9 5.18V5C9 4.20435 9.31607 3.44129 9.87868 2.87868C10.4413 2.31607 11.2044 2 12 2C12.7956 2 13.5587 2.31607 14.1213 2.87868C14.6839 3.44129 15 4.20435 15 5V11V11.16ZM4.27 3L21 19.73L19.73 21L15.54 16.81C14.77 17.27 13.91 17.58 13 17.72V21H11V17.72C7.72 17.23 5 14.41 5 11H6.7C6.7 14 9.24 16.1 12 16.1C12.81 16.1 13.6 15.91 14.31 15.58L12.65 13.92L12 14C11.2044 14 10.4413 13.6839 9.87868 13.1213C9.31607 12.5587 9 11.7956 9 11V10.28L3 4.27L4.27 3Z'
        fill='currentColor'
      />
    </svg>
  )
}

export function CircleUpIcon({ size = 24 }) {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22C10.6868 22 9.38642 21.7413 8.17317 21.2388C6.95991 20.7362 5.85752 19.9997 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C13.3132 2 14.6136 2.25866 15.8268 2.7612C17.0401 3.26375 18.1425 4.00035 19.0711 4.92893C19.9997 5.85752 20.7362 6.95991 21.2388 8.17317C21.7413 9.38642 22 10.6868 22 12ZM7.4 15.4L12 10.8L16.6 15.4L18 14L12 8L6 14L7.4 15.4Z'
        fill='currentColor'
      />
    </svg>
  )
}

export function HandIcon({ size = 24 }) {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M12.0819 22C9.26277 22 6.72901 20.3333 5.68265 17.8333L3.06241 11.475C2.79434 10.8167 3.43426 10.1583 4.13472 10.375L4.81788 10.5917C5.30215 10.75 5.69994 11.1 5.89019 11.5583L7.10951 14.5H7.75808V4.70833C7.75808 4.13333 8.24235 3.66667 8.83903 3.66667C9.43572 3.66667 9.91999 4.13333 9.91999 4.70833V12H10.7847V3.04167C10.7847 2.46667 11.269 2 11.8657 2C12.4624 2 12.9467 2.46667 12.9467 3.04167V12H13.8114V4.29167C13.8114 3.71667 14.2957 3.25 14.8924 3.25C15.4891 3.25 15.9733 3.71667 15.9733 4.29167V12H16.8381V6.79167C16.8381 6.21667 17.3224 5.75 17.919 5.75C18.5157 5.75 19 6.21667 19 6.79167V15.3333C19 19.0167 15.9041 22 12.0819 22Z'
        fill='currentColor'
      />
    </svg>
  )
}

export function SettingsIcon({ size = 24 }) {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M11.9989 15.5C11.0706 15.5 10.1804 15.1313 9.52399 14.4749C8.86761 13.8185 8.49886 12.9283 8.49886 12C8.49886 11.0717 8.86761 10.1815 9.52399 9.52513C10.1804 8.86875 11.0706 8.5 11.9989 8.5C12.9271 8.5 13.8174 8.86875 14.4737 9.52513C15.1301 10.1815 15.4989 11.0717 15.4989 12C15.4989 12.9283 15.1301 13.8185 14.4737 14.4749C13.8174 15.1313 12.9271 15.5 11.9989 15.5ZM19.4289 12.97C19.4689 12.65 19.4989 12.33 19.4989 12C19.4989 11.67 19.4689 11.34 19.4289 11L21.5389 9.37C21.7289 9.22 21.7789 8.95 21.6589 8.73L19.6589 5.27C19.5389 5.05 19.2689 4.96 19.0489 5.05L16.5589 6.05C16.0389 5.66 15.4989 5.32 14.8689 5.07L14.4989 2.42C14.4589 2.18 14.2489 2 13.9989 2H9.99886C9.74886 2 9.53886 2.18 9.49886 2.42L9.12886 5.07C8.49886 5.32 7.95886 5.66 7.43886 6.05L4.94886 5.05C4.72886 4.96 4.45886 5.05 4.33886 5.27L2.33886 8.73C2.20886 8.95 2.26886 9.22 2.45886 9.37L4.56886 11C4.52886 11.34 4.49886 11.67 4.49886 12C4.49886 12.33 4.52886 12.65 4.56886 12.97L2.45886 14.63C2.26886 14.78 2.20886 15.05 2.33886 15.27L4.33886 18.73C4.45886 18.95 4.72886 19.03 4.94886 18.95L7.43886 17.94C7.95886 18.34 8.49886 18.68 9.12886 18.93L9.49886 21.58C9.53886 21.82 9.74886 22 9.99886 22H13.9989C14.2489 22 14.4589 21.82 14.4989 21.58L14.8689 18.93C15.4989 18.67 16.0389 18.34 16.5589 17.94L19.0489 18.95C19.2689 19.03 19.5389 18.95 19.6589 18.73L21.6589 15.27C21.7789 15.05 21.7289 14.78 21.5389 14.63L19.4289 12.97Z'
        fill='currentColor'
      />
    </svg>
  )
}

export function ChevronDoubleUpIcon({ size = 24 }) {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M7.41 18.41L6 17L12 11L18 17L16.59 18.41L12 13.83L7.41 18.41ZM7.41 12.41L6 11L12 5L18 11L16.59 12.41L12 7.83L7.41 12.41Z'
        fill='currentColor'
      />
    </svg>
  )
}
